export enum TPShielding {
  STP = 'STP',
  UTP = 'UTP',
}
